import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/icons/close_24.svg'


const _hoisted_1 = {
  key: 0,
  class: "slide-header"
}
const _hoisted_2 = {
  key: 0,
  class: "header-left"
}
const _hoisted_3 = {
  key: 1,
  class: "slide-header"
}
const _hoisted_4 = {
  key: 2,
  class: "slide-header"
}

import {onUnmounted, reactive, ref, computed, watch} from "vue";
import { usePointerSwipe } from '@vueuse/core'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import {isMobileDevice} from '@/utils/windowUtils';


export default /*@__PURE__*/_defineComponent({
  __name: 'BottomSlideSheet',
  props: {
  title: {
    default: ''
  },
  footer: {
    default: false,
  },
  visible: {
    default: false,
  },
  hideExit: {
    default: false,
  },
  maxHeight: {
    default: false,
  }
},
  emits: ["update:visible", "cancel"],
  setup(__props, { emit: __emit }) {

const emits = __emit

const props = __props
const closeSlide = () => {
  if (contentRef.value) {
    enableBodyScroll(contentRef.value); // 명시적 해제
  }
  clearAllBodyScrollLocks()
  emits("cancel")
  emits("update:visible", false);
}
const footerRef = ref();
const contentRef = ref();
const frameRef = ref();
const start = ref();
const diff = ref();
const heights = reactive({
  frame: {
    default: -1,
    start: -1,
  },
  content: {
    default: -1,
    start: -1,
  },
  footer: {
    default: -1,
  },
});
const getFooterBottom = () => {
  return footerRef.value.getBoundingClientRect().bottom;
};

const { distanceY, isSwiping } = usePointerSwipe(frameRef, {
  onSwipeEnd(e, direction) {
    if (distanceY.value < -100 && direction === 'down') {
      closeSlide()
    }
  },
})

const transformStyle = computed(() => {
  if (isSwiping.value && distanceY.value < 0) {
    return {
      transform: `translateY(${-distanceY.value}px)`,
      transition: 'none' // 드래그 중에는 애니메이션 무효화
    }
  }
  return {
    transform: `translateY(0px)`,
    transition: 'transform 0.3s ease-out'
  }
})

const clickBack = () => {
  if (!props.hideExit) {
    closeSlide()
  }
}

watch(() => props.visible, (val) => {
  if (val) {
    setTimeout(() => {
      if (contentRef.value) {
        disableBodyScroll(contentRef.value, {
          reserveScrollBarGap: true,
        });
      }
    }, 0);
  } else {
    if (contentRef.value) {
      enableBodyScroll(contentRef.value);
    }
  }
}, { immediate: true })

onUnmounted(() => {
  clearAllBodyScrollLocks()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#teleport" }, [
    (__props.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["bottom-slide-sheet", { visible: __props.visible }])
        }, [
          _createElementVNode("div", {
            class: "slide-back",
            onClick: clickBack
          }),
          _createElementVNode("div", {
            class: "slide-frame",
            style: _normalizeStyle(transformStyle.value),
            ref_key: "frameRef",
            ref: frameRef
          }, [
            (__props.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  (!__props.hideExit)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(__props.title)), 1),
                  (!__props.hideExit)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _imports_0,
                        class: "cursor-pointer",
                        onClick: closeSlide
                      }))
                    : _createCommentVNode("", true)
                ]))
              : (!__props.title && !_unref(isMobileDevice)())
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "header-left" }, null, -1)),
                    _cache[1] || (_cache[1] = _createElementVNode("span", null, null, -1)),
                    _createElementVNode("img", {
                      src: _imports_0,
                      onClick: closeSlide
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[2] || (_cache[2] = [
                    _createElementVNode("div", { class: "top-bar" }, null, -1)
                  ]))),
            _createElementVNode("div", {
              class: _normalizeClass([__props.maxHeight ? 'slide-content-max' : '', "slide-content"]),
              ref_key: "contentRef",
              ref: contentRef
            }, [
              _renderSlot(_ctx.$slots, "content")
            ], 2),
            (__props.footer)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "slide-footer",
                  ref_key: "footerRef",
                  ref: footerRef
                }, [
                  _renderSlot(_ctx.$slots, "footer")
                ], 512))
              : _createCommentVNode("", true)
          ], 4)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})